import { z } from "zod/v4";

import { InputRequirementSchema } from "./nodes/input-requirement";
import { ExecutionMetricsSchema } from "./execution-metrics";
import { ExecutionErrorSchema } from "./node-execution";

export const BaseNodeExecutionResultSchema = z.object({
  startTs: z.number(),
  endTs: z.number(),
  success: z.boolean(),
  nextNodeId: z.string().optional(),
  error: ExecutionErrorSchema.optional(),
  requiresInput: InputRequirementSchema.optional(),
  metrics: ExecutionMetricsSchema.optional(),
  updatedContext: z.any(),
});

export type BaseNodeExecutionResult = z.infer<
  typeof BaseNodeExecutionResultSchema
>;
